import { createGlobalStyle } from "styled-components"

export const GlobalStyle = createGlobalStyle`
    body {
        background: ${({ theme }) => theme.body};
        color: ${({ theme }) => theme.text};
    }

    .apexcharts-tooltip-title,
    .apexcharts-menu-item,
    .apexcharts-tooltip {
        background: ${({ theme }) => theme.body} !important;
        color: ${({ theme }) => theme.text} !important;
    }
`